import { createContext } from "react";
import type { ApiAccessContextType } from "@repo/types/contexts";

const ApiAccessContext = createContext<ApiAccessContextType | null>(null);

export { ApiAccessContext };
